import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Heart, MailOpen } from 'lucide-react';

const Letter: React.FC = () => {
    const { t } = useLanguage();

    return (
        <div className="px-6 py-6 flex flex-col items-center">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="max-w-4xl w-full bg-[#FFFBF0] dark:bg-[#2C2C2E] p-6 md:p-10 rounded-[2.5rem] shadow-2xl border-2 border-[#F3E5AB] dark:border-gray-700 relative overflow-hidden"
            >
                {/* Paper texture effect */}
                <div className="absolute inset-0 opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/paper-fibers.png')]" />

                {/* Letter Head */}
                <div className="flex flex-col items-center mb-8 relative z-10">
                    <motion.div
                        animate={{ rotate: [0, -5, 5, 0] }}
                        transition={{ repeat: Infinity, duration: 4 }}
                        className="w-14 h-14 bg-primary-red/10 rounded-full flex items-center justify-center mb-4"
                    >
                        <MailOpen className="text-primary-red" size={28} />
                    </motion.div>
                    <h2 className="text-xl md:text-2xl font-playfair font-bold text-primary-red">
                        {t('home.letterTitle')}
                    </h2>
                    <div className="h-0.5 w-10 bg-primary-red/30 mt-3" />
                </div>

                {/* Letter Content */}
                <div className="relative z-10">
                    <p className="text-sm md:text-base font-poppins leading-relaxed text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                        {t('home.letterContent')}
                    </p>
                </div>

                {/* Letter Footer */}
                <div className="mt-8 flex flex-col items-end relative z-10">
                    <div className="flex flex-col items-center">
                        <p className="font-playfair font-bold text-base text-primary-red mb-1 italic">With all my love,</p>
                        <motion.div
                            animate={{ scale: [1, 1.1, 1] }}
                            transition={{ repeat: Infinity, duration: 1.5 }}
                            className="text-primary-red"
                        >
                            <Heart fill="currentColor" size={20} />
                        </motion.div>
                    </div>
                </div>

                {/* Decorative elements */}
                <div className="absolute top-6 right-6 text-primary-red/5">
                    <Heart size={80} />
                </div>
                <div className="absolute bottom-6 left-6 text-primary-red/5">
                    <Heart size={60} />
                </div>
            </motion.div>

            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 0.5 }}
                className="mt-8 text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest"
            >
                A letter from my soul to yours
            </motion.p>
        </div>
    );
};

export default Letter;
